module.exports = __webpack_public_path__ + "static/media/trash.b32b8bd4.svg";